import { render, staticRenderFns } from "./c-password-reset-request-card.vue?vue&type=template&id=2928c997&scoped=true&"
import script from "./c-password-reset-request-card.vue?vue&type=script&lang=js&"
export * from "./c-password-reset-request-card.vue?vue&type=script&lang=js&"
import style0 from "./c-password-reset-request-card.vue?vue&type=style&index=0&id=2928c997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928c997",
  null
  
)

export default component.exports